import { render } from "./app-promotion.vue?vue&type=template&id=05a6345a"
import script from "./app-promotion.vue?vue&type=script&lang=js"
export * from "./app-promotion.vue?vue&type=script&lang=js"

import exportComponent from "/Users/nathan/Dev/justcuts-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__